import { render, staticRenderFns } from "./SinisterInspection.vue?vue&type=template&id=59bb6fba&scoped=true"
import script from "./SinisterInspection.vue?vue&type=script&lang=ts"
export * from "./SinisterInspection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb6fba",
  null
  
)

export default component.exports